export const comics = [
  {
    id: 0,
    title: "Nanami's Method",
    coverUrl: "/comic0_cover.jpg",
    locked: true,
    isFeatured: true,
    buyUrl: "https://payhip.com/b/UkmBs",
    pages: [
      { id: 1, imageUrl: "/comic0_cover.jpg" },
      { id: 2, imageUrl: "/comics/0/page1.jpg" },
      { id: 3, imageUrl: "/comics/0/page2.jpg" },
      { id: 4, imageUrl: "/comics/0/page3.jpg" },
      { id: 5, imageUrl: "/comics/0/page4.jpg" },
      { id: 6, imageUrl: "/comics/0/page5.jpg" },
    ],
    pagesEs: [
      { id: 1, imageUrl: "/comic0_cover.jpg" },
      { id: 2, imageUrl: "/comics/0/es/page1.jpg" },
      { id: 3, imageUrl: "/comics/0/es/page2.jpg" },
      { id: 4, imageUrl: "/comics/0/es/page3.jpg" },
      { id: 5, imageUrl: "/comics/0/es/page4.jpg" },
      { id: 6, imageUrl: "/comics/0/es/page5.jpg" },
    ],
    coverUrlEs: "/comic0_cover.jpg",
  },
  {
    id: 1,
    title: "Gohan's Wish",
    coverUrl: "/comic1_cover.jpg",
    locked: true,
    pages: [
      { id: 1, imageUrl: "/comic1_cover.jpg" },
      { id: 2, imageUrl: "/comic1_page1.jpg" },
      { id: 3, imageUrl: "/comic1_page2.jpg" },
      { id: 4, imageUrl: "/comic1_page3.jpg" },
      { id: 5, imageUrl: "/comic1_page4.jpg" },
      { id: 6, imageUrl: "/comic1_page5.jpg" },
    ],
    // Spanish version pages
    pagesEs: [
      { id: 1, imageUrl: "/comics/1/es/cover.jpg" },
      { id: 2, imageUrl: "/comics/1/es/page1.jpg" },
      { id: 3, imageUrl: "/comics/1/es/page2.jpg" },
      { id: 4, imageUrl: "/comics/1/es/page3.jpg" },
      { id: 5, imageUrl: "/comics/1/es/page4.jpg" },
      { id: 6, imageUrl: "/comics/1/es/page5.jpg" },
    ],
    coverUrlEs: "/comics/1/es/cover.jpg",
  },
  {
    id: 2,
    title: "Study Break",
    coverUrl: "/comic2-cover.jpg",
    locked: false,
    pages: [
      { id: 1, imageUrl: "/comic2-cover.jpg" },
      { id: 2, imageUrl: "/comic2-page1.jpg" },
      { id: 3, imageUrl: "/comic2-page2.jpg" },
      { id: 4, imageUrl: "/comic2-page3.jpg" },
      { id: 5, imageUrl: "/comic2-page4.jpg" },
      { id: 6, imageUrl: "/comic2-page5.jpg" },
      { id: 7, imageUrl: "/comic2-page6.jpg" },
      { id: 8, imageUrl: "/comic2-page7.jpg" },
      { id: 9, imageUrl: "/comic2-page8.jpg" },
      { id: 10, imageUrl: "/comic2-page9.jpg" },
      { id: 11, imageUrl: "/comic2-page10.jpg" },
      { id: 12, imageUrl: "/comic2-page11.jpg" },
      { id: 13, imageUrl: "/comic2-page12.jpg" },
      { id: 14, imageUrl: "/comic2-page13.jpg" },
      { id: 15, imageUrl: "/comic2-page14.jpg" },
      { id: 16, imageUrl: "/comic2-page15.jpg" },
    ],
    // Spanish version pages
    pagesEs: [
      { id: 1, imageUrl: "/comics/2/es/cover.jpg" },
      { id: 2, imageUrl: "/comics/2/es/page1.jpg" },
      { id: 3, imageUrl: "/comics/2/es/page2.jpg" },
      { id: 4, imageUrl: "/comics/2/es/page3.jpg" },
      { id: 5, imageUrl: "/comics/2/es/page4.jpg" },
      { id: 6, imageUrl: "/comics/2/es/page5.jpg" },
      { id: 7, imageUrl: "/comics/2/es/page6.jpg" },
      { id: 8, imageUrl: "/comics/2/es/page7.jpg" },
      { id: 9, imageUrl: "/comics/2/es/page8.jpg" },
      { id: 10, imageUrl: "/comics/2/es/page9.jpg" },
      { id: 11, imageUrl: "/comics/2/es/page10.jpg" },
      { id: 12, imageUrl: "/comics/2/es/page11.jpg" },
      { id: 13, imageUrl: "/comics/2/es/page12.jpg" },
      { id: 14, imageUrl: "/comics/2/es/page13.jpg" },
    ],
    coverUrlEs: "/comics/2/es/cover.jpg",
  },
  {
    id: 3,
    title: "Worshipping in the Dangerous Future",
    coverUrl: "/comic3_cover.jpg",
    locked: true,
    pages: [
      { id: 1, imageUrl: "/comic3_cover.jpg" },
      { id: 2, imageUrl: "/comic3_page1.jpg" },
      { id: 3, imageUrl: "/comic3_page2.jpg" },
      { id: 4, imageUrl: "/comic3_page3.jpg" },
      { id: 5, imageUrl: "/comic3_page4.jpg" },
      { id: 6, imageUrl: "/comic3_page5.jpg" },
      { id: 7, imageUrl: "/comic3_page6.jpg" },
      { id: 8, imageUrl: "/comic3_page7.jpg" },
      { id: 9, imageUrl: "/comic3_page8.jpg" },
      { id: 10, imageUrl: "/comic3_page9.jpg" },
      { id: 11, imageUrl: "/comic3_page10.jpg" },
      { id: 12, imageUrl: "/comic3_page11.jpg" },
      { id: 13, imageUrl: "/comic3_page12.jpg" },
      { id: 14, imageUrl: "/comic3_page13.jpg" },
      { id: 15, imageUrl: "/comic3_page14.jpg" },
      { id: 16, imageUrl: "/comic3_page15.jpg" },
      { id: 17, imageUrl: "/comic3_page16.jpg" },
    ],
    // Spanish version pages
    pagesEs: [
      { id: 1, imageUrl: "/comics/3/es/cover.jpg" },
      { id: 2, imageUrl: "/comics/3/es/page1.jpg" },
      { id: 3, imageUrl: "/comics/3/es/page2.jpg" },
      { id: 4, imageUrl: "/comics/3/es/page3.jpg" },
      { id: 5, imageUrl: "/comics/3/es/page4.jpg" },
      { id: 6, imageUrl: "/comics/3/es/page5.jpg" },
      { id: 7, imageUrl: "/comics/3/es/page6.jpg" },
      { id: 8, imageUrl: "/comics/3/es/page7.jpg" },
      { id: 9, imageUrl: "/comics/3/es/page8.jpg" },
      { id: 10, imageUrl: "/comics/3/es/page9.jpg" },
      { id: 11, imageUrl: "/comics/3/es/page10.jpg" },
      { id: 12, imageUrl: "/comics/3/es/page11.jpg" },
      { id: 13, imageUrl: "/comics/3/es/page12.jpg" },
      { id: 14, imageUrl: "/comics/3/es/page13.jpg" },
      { id: 15, imageUrl: "/comics/3/es/page14.jpg" },
    ],
    coverUrlEs: "/comics/3/es/cover.jpg",
  },
  {
    id: 4,
    title: "My Best Friend Feet",
    coverUrl: "/comic4_cover.jpg",
    locked: true,
    pages: [
      { id: 1, imageUrl: "/comic4_cover.jpg" },
      { id: 2, imageUrl: "/comic4_page1.jpg" },
      { id: 3, imageUrl: "/comic4_page2.jpg" },
      { id: 4, imageUrl: "/comic4_page3.jpg" },
      { id: 5, imageUrl: "/comic4_page4.jpg" },
      { id: 6, imageUrl: "/comic4_page5.jpg" },
      { id: 7, imageUrl: "/comic4_page6.jpg" },
      { id: 8, imageUrl: "/comic4_page7.jpg" },
      { id: 9, imageUrl: "/comic4_page8.jpg" },
      { id: 10, imageUrl: "/comic4_page9.jpg" },
      { id: 11, imageUrl: "/comic4_page10.jpg" },
      { id: 12, imageUrl: "/comic4_page11.jpg" },
      { id: 13, imageUrl: "/comic4_page12.jpg" },
      { id: 14, imageUrl: "/comic4_page13.jpg" },
      { id: 15, imageUrl: "/comic4_page14.jpg" },
      { id: 16, imageUrl: "/comic4_page15.jpg" },
    ],
    // Spanish version pages
    pagesEs: [
      { id: 1, imageUrl: "/comics/4/es/cover.jpg" },
      { id: 2, imageUrl: "/comics/4/es/page1.jpg" },
      { id: 3, imageUrl: "/comics/4/es/page2.jpg" },
      { id: 4, imageUrl: "/comics/4/es/page3.jpg" },
      { id: 5, imageUrl: "/comics/4/es/page4.jpg" },
      { id: 6, imageUrl: "/comics/4/es/page5.jpg" },
      { id: 7, imageUrl: "/comics/4/es/page6.jpg" },
      { id: 8, imageUrl: "/comics/4/es/page7.jpg" },
      { id: 9, imageUrl: "/comics/4/es/page8.jpg" },
      { id: 10, imageUrl: "/comics/4/es/page9.jpg" },
      { id: 11, imageUrl: "/comics/4/es/page10.jpg" },
      { id: 12, imageUrl: "/comics/4/es/page11.jpg" },
      { id: 13, imageUrl: "/comics/4/es/page12.jpg" },
      { id: 14, imageUrl: "/comics/4/es/page13.jpg" },
    ],
    coverUrlEs: "/comics/4/es/cover.jpg",
  },
  {
    id: 5,
    title: "Dragon Ball Super: Barefoot Heroes",
    coverUrl: "/comic5_cover.jpg",
    locked: true,
    pages: [
      { id: 1, imageUrl: "/comic5_cover.jpg" },
      { id: 2, imageUrl: "/comic5_page1.jpg" },
      { id: 3, imageUrl: "/comic5_page2.jpg" },
      { id: 4, imageUrl: "/comic5_page3.jpg" },
      { id: 5, imageUrl: "/comic5_page4.jpg" },
      { id: 6, imageUrl: "/comic5_page5.jpg" },
      { id: 7, imageUrl: "/comic5_page6.jpg" },
      { id: 8, imageUrl: "/comic5_page7.jpg" },
      { id: 9, imageUrl: "/comic5_page8.jpg" },
      { id: 10, imageUrl: "/comic5_page9.jpg" },
      { id: 11, imageUrl: "/comic5_page10.jpg" },
      { id: 12, imageUrl: "/comic5_page11.jpg" },
      { id: 13, imageUrl: "/comic5_page12.jpg" },
      { id: 14, imageUrl: "/comic5_page13.jpg" },
      { id: 15, imageUrl: "/comic5_page14.jpg" },
      { id: 16, imageUrl: "/comic5_page15.jpg" },
      { id: 17, imageUrl: "/comic5_page16.jpg" },
      { id: 18, imageUrl: "/comic5_page17.jpg" },
      { id: 19, imageUrl: "/comic5_page18.jpg" },
      { id: 20, imageUrl: "/comic5_page19.jpg" },
      { id: 21, imageUrl: "/comic5_page20.jpg" },
      { id: 22, imageUrl: "/comic5_page21.jpg" },
      { id: 23, imageUrl: "/comic5_page22.jpg" },
    ],
    // Spanish version pages
    pagesEs: [
      { id: 1, imageUrl: "/comics/5/es/cover.jpg" },
      { id: 2, imageUrl: "/comics/5/es/page1.jpg" },
      { id: 3, imageUrl: "/comics/5/es/page2.jpg" },
      { id: 4, imageUrl: "/comics/5/es/page3.jpg" },
      { id: 5, imageUrl: "/comics/5/es/page4.jpg" },
      { id: 6, imageUrl: "/comics/5/es/page5.jpg" },
      { id: 7, imageUrl: "/comics/5/es/page6.jpg" },
      { id: 8, imageUrl: "/comics/5/es/page7.jpg" },
      { id: 9, imageUrl: "/comics/5/es/page8.jpg" },
      { id: 10, imageUrl: "/comics/5/es/page9.jpg" },
      { id: 11, imageUrl: "/comics/5/es/page10.jpg" },
      { id: 12, imageUrl: "/comics/5/es/page11.jpg" },
      { id: 13, imageUrl: "/comics/5/es/page12.jpg" },
      { id: 14, imageUrl: "/comics/5/es/page13.jpg" },
      { id: 15, imageUrl: "/comics/5/es/page14.jpg" },
      { id: 16, imageUrl: "/comics/5/es/page15.jpg" },
      { id: 17, imageUrl: "/comics/5/es/page16.jpg" },
      { id: 18, imageUrl: "/comics/5/es/page17.jpg" },
      { id: 19, imageUrl: "/comics/5/es/page18.jpg" },
      { id: 20, imageUrl: "/comics/5/es/page19.jpg" },
      { id: 21, imageUrl: "/comics/5/es/page20.jpg" },
      { id: 22, imageUrl: "/comics/5/es/page21.jpg" },
    ],
    coverUrlEs: "/comics/5/es/cover.jpg",
  },
  {
    id: 6,
    title: "Join My Pirate Crew",
    coverUrl: "/comic6_cover.jpg",
    locked: true,
    pages: [
      { id: 1, imageUrl: "/comic6_cover.jpg" },
      { id: 2, imageUrl: "/comic6_page1.jpg" },
      { id: 3, imageUrl: "/comic6_page2.jpg" },
      { id: 4, imageUrl: "/comic6_page3.jpg" },
      { id: 5, imageUrl: "/comic6_page4.jpg" },
    ],
    // Spanish version pages
    pagesEs: [
      { id: 1, imageUrl: "/comics/6/es/cover.jpg" },
      { id: 2, imageUrl: "/comics/6/es/page1.jpg" },
      { id: 3, imageUrl: "/comics/6/es/page2.jpg" },
      { id: 4, imageUrl: "/comics/6/es/page3.jpg" },
      { id: 5, imageUrl: "/comics/6/es/page4.jpg" },
    ],
    coverUrlEs: "/comics/6/es/cover.jpg",
  },
  {
    id: 7,
    title: "The Real Winner",
    coverUrl: "/comic7_cover.jpg",
    locked: true,
    pages: [
      { id: 1, imageUrl: "/comic7_cover.jpg" },
      { id: 2, imageUrl: "/comic7_page1.jpg" },
      { id: 3, imageUrl: "/comic7_page2.jpg" },
      { id: 4, imageUrl: "/comic7_page3.jpg" },
      { id: 5, imageUrl: "/comic7_page4.jpg" },
    ],
    // Spanish version pages
    pagesEs: [
      { id: 1, imageUrl: "/comics/7/es/cover.jpg" },
      { id: 2, imageUrl: "/comics/7/es/page1.jpg" },
      { id: 3, imageUrl: "/comics/7/es/page2.jpg" },
      { id: 4, imageUrl: "/comics/7/es/page3.jpg" },
      { id: 5, imageUrl: "/comics/7/es/page4.jpg" },
    ],
    coverUrlEs: "/comics/7/es/cover.jpg",
  },
  {
    id: 8,
    title: "The Real Winner 2",
    coverUrl: "/comic8_cover.jpg",
    locked: true,
    pages: [
      { id: 1, imageUrl: "/comic8_cover.jpg" },
      { id: 2, imageUrl: "/comic8_page1.jpg" },
      { id: 3, imageUrl: "/comic8_page2.jpg" },
      { id: 4, imageUrl: "/comic8_page3.jpg" },
      { id: 5, imageUrl: "/comic8_page4.jpg" },
    ],
    // Spanish version pages
    pagesEs: [
      { id: 1, imageUrl: "/comics/8/es/cover.jpg" },
      { id: 2, imageUrl: "/comics/8/es/page1.jpg" },
      { id: 3, imageUrl: "/comics/8/es/page2.jpg" },
      { id: 4, imageUrl: "/comics/8/es/page3.jpg" },
      { id: 5, imageUrl: "/comics/8/es/page4.jpg" },
    ],
    coverUrlEs: "/comics/8/es/cover.jpg",
  },
  {
    id: 9,
    title: "The Real Winner 3",
    coverUrl: "/comic9_cover.jpg",
    locked: true,
    pages: [
      { id: 1, imageUrl: "/comic9_cover.jpg" },
      { id: 2, imageUrl: "/comic9_page1.jpg" },
      { id: 3, imageUrl: "/comic9_page2.jpg" },
      { id: 4, imageUrl: "/comic9_page3.jpg" },
      { id: 5, imageUrl: "/comic9_page4.jpg" },
      { id: 6, imageUrl: "/comic9_page5.jpg" },
    ],
    // Spanish version pages
    pagesEs: [
      { id: 1, imageUrl: "/comics/9/es/cover.jpg" },
      { id: 2, imageUrl: "/comics/9/es/page1.jpg" },
      { id: 3, imageUrl: "/comics/9/es/page2.jpg" },
      { id: 4, imageUrl: "/comics/9/es/page3.jpg" },
      { id: 5, imageUrl: "/comics/9/es/page4.jpg" },
      { id: 6, imageUrl: "/comics/9/es/page5.jpg" },
    ],
    coverUrlEs: "/comics/9/es/cover.jpg",
  },
  {
    id: 10,
    title: "After Training",
    coverUrl: "/comic10_cover.jpg",
    locked: true,
    pages: [
      { id: 1, imageUrl: "/comic10_cover.jpg" },
      { id: 2, imageUrl: "/comic10_page1.jpg" },
      { id: 3, imageUrl: "/comic10_page2.jpg" },
      { id: 4, imageUrl: "/comic10_page3.jpg" },
      { id: 5, imageUrl: "/comic10_page4.jpg" },
      { id: 6, imageUrl: "/comic10_page5.jpg" },
      { id: 7, imageUrl: "/comic10_page6.jpg" },
      { id: 8, imageUrl: "/comic10_page7.jpg" },
      { id: 9, imageUrl: "/comic10_page8.jpg" },
    ],
    // Spanish version pages
    pagesEs: [
      { id: 1, imageUrl: "/comics/10/es/cover.jpg" },
      { id: 2, imageUrl: "/comics/10/es/page1.jpg" },
      { id: 3, imageUrl: "/comics/10/es/page2.jpg" },
      { id: 4, imageUrl: "/comics/10/es/page3.jpg" },
      { id: 5, imageUrl: "/comics/10/es/page4.jpg" },
      { id: 6, imageUrl: "/comics/10/es/page5.jpg" },
      { id: 7, imageUrl: "/comics/10/es/page6.jpg" },
      { id: 8, imageUrl: "/comics/10/es/page7.jpg" },
      { id: 9, imageUrl: "/comics/10/es/page8.jpg" },
    ],
    coverUrlEs: "/comics/10/es/cover.jpg",
  },
  {
    id: 11,
    title: "A Tempting Offer for Bakugo",
    coverUrl: "/comic11_cover.jpg",
    locked: true,
    pages: [
      { id: 1, imageUrl: "/comic11_cover.jpg" },
      { id: 2, imageUrl: "/comic11_page1.jpg" },
      { id: 3, imageUrl: "/comic11_page2.jpg" },
      { id: 4, imageUrl: "/comic11_page3.jpg" },
      { id: 5, imageUrl: "/comic11_page4.jpg" },
    ],
    // Spanish version pages
    pagesEs: [
      { id: 1, imageUrl: "/comics/11/es/cover.jpg" },
      { id: 2, imageUrl: "/comics/11/es/page1.jpg" },
      { id: 3, imageUrl: "/comics/11/es/page2.jpg" },
      { id: 4, imageUrl: "/comics/11/es/page3.jpg" },
      { id: 5, imageUrl: "/comics/11/es/page4.jpg" },
    ],
    coverUrlEs: "/comics/11/es/cover.jpg",
  },
  {
    id: 12,
    title: "A Stinky Dream",
    coverUrl: "/comic12_cover.jpg",
    locked: true,
    pages: [
      { id: 1, imageUrl: "/comic12_cover.jpg" },
      { id: 2, imageUrl: "/comic12_page1.jpg" },
      { id: 3, imageUrl: "/comic12_page2.jpg" },
      { id: 4, imageUrl: "/comic12_page3.jpg" },
      { id: 5, imageUrl: "/comic12_page4.jpg" },
      { id: 6, imageUrl: "/comic12_page5.jpg" },
    ],
    // Spanish version pages
    pagesEs: [
      { id: 1, imageUrl: "/comics/12/es/cover.jpg" },
      { id: 2, imageUrl: "/comics/12/es/page1.jpg" },
      { id: 3, imageUrl: "/comics/12/es/page2.jpg" },
      { id: 4, imageUrl: "/comics/12/es/page3.jpg" },
      { id: 5, imageUrl: "/comics/12/es/page4.jpg" },
      { id: 6, imageUrl: "/comics/12/es/page5.jpg" },
    ],
    coverUrlEs: "/comics/12/es/cover.jpg",
  },
  {
    id: 13,
    title: "Uzui's New Wives",
    coverUrl: "/comic13_cover.jpg",
    locked: true,
    pages: [
      { id: 1, imageUrl: "/comic13_cover.jpg" },
      { id: 2, imageUrl: "/comic13_page1.jpg" },
      { id: 3, imageUrl: "/comic13_page2.jpg" },
      { id: 4, imageUrl: "/comic13_page3.jpg" },
      { id: 5, imageUrl: "/comic13_page4.jpg" },
      { id: 6, imageUrl: "/comic13_page5.jpg" },
    ],
    // Spanish version pages
    pagesEs: [
      { id: 1, imageUrl: "/comics/13/es/cover.jpg" },
      { id: 2, imageUrl: "/comics/13/es/page1.jpg" },
      { id: 3, imageUrl: "/comics/13/es/page2.jpg" },
      { id: 4, imageUrl: "/comics/13/es/page3.jpg" },
      { id: 5, imageUrl: "/comics/13/es/page4.jpg" },
      { id: 6, imageUrl: "/comics/13/es/page5.jpg" },
    ],
    coverUrlEs: "/comics/13/es/cover.jpg",
  },
  {
    id: 14,
    title: "Gon and Killua's secret game",
    coverUrl: "/comics/14/cover.jpg",
    locked: true,
    buyUrl: "https://payhip.com/b/Z4GLo",
    pages: [
      { id: 1, imageUrl: "/comics/14/cover.jpg" },
      { id: 2, imageUrl: "/comics/14/Pag1.jpg" },
      { id: 3, imageUrl: "/comics/14/Pag2.jpg" },
      { id: 4, imageUrl: "/comics/14/Pag3.jpg" },
      { id: 5, imageUrl: "/comics/14/Pag4.jpg" },
      { id: 6, imageUrl: "/comics/14/Pag5.jpg" },
    ],
    pagesEs: [
      { id: 1, imageUrl: "/comics/14/es/cover.jpg" },
      { id: 2, imageUrl: "/comics/14/es/Pag1_esp.jpg" },
      { id: 3, imageUrl: "/comics/14/es/Pag2_esp.jpg" },
      { id: 4, imageUrl: "/comics/14/es/Pag3_esp.jpg" },
      { id: 5, imageUrl: "/comics/14/es/Pag4_esp.jpg" },
      { id: 6, imageUrl: "/comics/14/es/Pag5_esp.jpg" },
    ],
    coverUrlEs: "/comics/14/es/cover.jpg",
  },
  {
    id: 15,
    title: "Goku and Vegeta's Humiliation",
    coverUrl: "/comics/15/cover.jpg",
    locked: true,
    isFeatured: true,
    buyUrl: "https://payhip.com/b/aEzKm",
    pages: [
      { id: 1, imageUrl: "/comics/15/cover.jpg" },
      { id: 2, imageUrl: "/comics/15/Pag1.jpg" },
      { id: 3, imageUrl: "/comics/15/Pag2.jpg" },
      { id: 4, imageUrl: "/comics/15/Pag3.jpg" },
      { id: 5, imageUrl: "/comics/15/Pag4.jpg" },
      { id: 6, imageUrl: "/comics/15/Pag5.jpg" },
    ],
    pagesEs: [
      { id: 1, imageUrl: "/comics/15/es/cover.jpg" },
      { id: 2, imageUrl: "/comics/15/es/Pag1_esp.jpg" },
      { id: 3, imageUrl: "/comics/15/es/Pag2_esp.jpg" },
      { id: 4, imageUrl: "/comics/15/es/Pag3_esp.jpg" },
      { id: 5, imageUrl: "/comics/15/es/Pag4_esp.jpg" },
      { id: 6, imageUrl: "/comics/15/es/Pag5_esp.jpg" },
    ],
    coverUrlEs: "/comics/15/es/cover.jpg",
  },
  {
    id: 16,
    title: "Sleepover at Todoroki's",
    coverUrl: "/comic16_cover.jpg",
    locked: true,
    buyUrl: "https://payhip.com/b/BHWAf",
    isEncrypted: true,
    pages: [
      { id: 1, imageUrl: "/comic16_cover.jpg" },
      { id: 2, imageUrl: "/comics/16/page1.enc" },
      { id: 3, imageUrl: "/comics/16/page2.enc" },
      { id: 4, imageUrl: "/comics/16/page3.enc" },
      { id: 5, imageUrl: "/comics/16/page4.enc" },
      { id: 6, imageUrl: "/comics/16/page5.enc" },
    ],
    pagesEs: [
      { id: 1, imageUrl: "/comic16_cover.jpg" },
      { id: 2, imageUrl: "/comics/16/es/page1.enc" },
      { id: 3, imageUrl: "/comics/16/es/page2.enc" },
      { id: 4, imageUrl: "/comics/16/es/page3.enc" },
      { id: 5, imageUrl: "/comics/16/es/page4.enc" },
      { id: 6, imageUrl: "/comics/16/es/page5.enc" },
    ],
    coverUrlEs: "/comic16_cover.jpg",
  },
  {
    id: 17,
    title: "This is your chance, Nakamura-kun!",
    coverUrl: "/comic17_cover.jpg",
    locked: true,
    buyUrl: "https://payhip.com/b/OXNgh",
    isEncrypted: true,
    pages: [
      { id: 1, imageUrl: "/comic17_cover.jpg" },
      { id: 2, imageUrl: "/comics/17/page1.enc" },
      { id: 3, imageUrl: "/comics/17/page2.enc" },
      { id: 4, imageUrl: "/comics/17/page3.enc" },
      { id: 5, imageUrl: "/comics/17/page4.enc" },
      { id: 6, imageUrl: "/comics/17/page5.enc" },
    ],
    pagesEs: [
      { id: 1, imageUrl: "/comic17_cover_es.jpg" },
      { id: 2, imageUrl: "/comics/17/es/page1.enc" },
      { id: 3, imageUrl: "/comics/17/es/page2.enc" },
      { id: 4, imageUrl: "/comics/17/es/page3.enc" },
      { id: 5, imageUrl: "/comics/17/es/page4.enc" },
      { id: 6, imageUrl: "/comics/17/es/page5.enc" },
    ],
    coverUrlEs: "/comic17_cover_es.jpg",
  },
  {
    id: 18,
    title: "The Real Winner 4 - Last chapter, Part I",
    coverUrl: "/comic18_cover.jpg",
    locked: true,
    buyUrl: "https://payhip.com/b/Jos3H",
    isEncrypted: true,
    pages: [
      { id: 1, imageUrl: "/comic18_cover.jpg" },
      { id: 2, imageUrl: "/comics/18/page1.enc" },
      { id: 3, imageUrl: "/comics/18/page2.enc" },
      { id: 4, imageUrl: "/comics/18/page3.enc" },
      { id: 5, imageUrl: "/comics/18/page4.enc" },
      { id: 6, imageUrl: "/comics/18/page5.enc" },
    ],
    pagesEs: [
      { id: 1, imageUrl: "/comic18_cover_es.jpg" },
      { id: 2, imageUrl: "/comics/18/es/page1.enc" },
      { id: 3, imageUrl: "/comics/18/es/page2.enc" },
      { id: 4, imageUrl: "/comics/18/es/page3.enc" },
      { id: 5, imageUrl: "/comics/18/es/page4.enc" },
      { id: 6, imageUrl: "/comics/18/es/page5.enc" },
    ],
    coverUrlEs: "/comic18_cover_es.jpg",
  },
  {
    id: 19,
    title: "Making you feel better",
    coverUrl: "/comic19_cover.jpg",
    locked: true,
    buyUrl: "https://payhip.com/b/2ioa5",
    isEncrypted: true,
    pages: [
      { id: 1, imageUrl: "/comic19_cover.jpg" },
      { id: 2, imageUrl: "/comics/19/page1.enc" },
      { id: 3, imageUrl: "/comics/19/page2.enc" },
      { id: 4, imageUrl: "/comics/19/page3.enc" },
      { id: 5, imageUrl: "/comics/19/page4.enc" },
      { id: 6, imageUrl: "/comics/19/page5.enc" },
    ],
    pagesEs: [
      { id: 1, imageUrl: "/comic19_cover_es.jpg" },
      { id: 2, imageUrl: "/comics/19/es/page1.enc" },
      { id: 3, imageUrl: "/comics/19/es/page2.enc" },
      { id: 4, imageUrl: "/comics/19/es/page3.enc" },
      { id: 5, imageUrl: "/comics/19/es/page4.enc" },
      { id: 6, imageUrl: "/comics/19/es/page5.enc" },
    ],
    coverUrlEs: "/comic19_cover_es.jpg",
  },
  {
    id: 20,
    title: "The Real Winner - Last chapter Part II",
    coverUrl: "/comic20_cover.jpg",
    locked: true,
    buyUrl: "https://payhip.com/b/VOt4P",
    isEncrypted: true,
    pages: [
      { id: 1, imageUrl: "/comic20_cover.jpg" },
      { id: 2, imageUrl: "/comics/20/page1.enc" },
      { id: 3, imageUrl: "/comics/20/page2.enc" },
      { id: 4, imageUrl: "/comics/20/page3.enc" },
      { id: 5, imageUrl: "/comics/20/page4.enc" },
      { id: 6, imageUrl: "/comics/20/page5.enc" },
      { id: 7, imageUrl: "/comics/20/page6.enc" },
    ],
    pagesEs: [
      { id: 1, imageUrl: "/comic20_cover_es.jpg" },
      { id: 2, imageUrl: "/comics/20/es/page1.enc" },
      { id: 3, imageUrl: "/comics/20/es/page2.enc" },
      { id: 4, imageUrl: "/comics/20/es/page3.enc" },
      { id: 5, imageUrl: "/comics/20/es/page4.enc" },
      { id: 6, imageUrl: "/comics/20/es/page5.enc" },
      { id: 7, imageUrl: "/comics/20/es/page6.enc" },
    ],
    coverUrlEs: "/comic20_cover_es.jpg",
  },
  {
    id: 21,
    title: "Nagi's decision",
    coverUrl: "/comic21_cover.jpg",
    locked: true,
    buyUrl: "https://payhip.com/b/8cyvP",
    isEncrypted: true,
    pages: [
      { id: 1, imageUrl: "/comic21_cover.jpg" },
      { id: 2, imageUrl: "/comics/21/page1.enc" },
      { id: 3, imageUrl: "/comics/21/page2.enc" },
      { id: 4, imageUrl: "/comics/21/page3.enc" },
      { id: 5, imageUrl: "/comics/21/page4.enc" },
      { id: 6, imageUrl: "/comics/21/page5.enc" },
      { id: 7, imageUrl: "/comics/21/page6.enc" },
    ],
    pagesEs: [
      { id: 1, imageUrl: "/comic21_cover_es.jpg" },
      { id: 2, imageUrl: "/comics/21/es/page1.enc" },
      { id: 3, imageUrl: "/comics/21/es/page2.enc" },
      { id: 4, imageUrl: "/comics/21/es/page3.enc" },
      { id: 5, imageUrl: "/comics/21/es/page4.enc" },
      { id: 6, imageUrl: "/comics/21/es/page5.enc" },
      { id: 7, imageUrl: "/comics/21/es/page6.enc" },
    ],
    coverUrlEs: "/comic21_cover_es.jpg",
  },
  {
    id: 22,
    title: "Before returning to the future",
    coverUrl: "/comic22_cover.jpg",
    locked: true,
    isFeatured: true,
    buyUrl: "https://payhip.com/b/woFCS",
    isEncrypted: true,
    pages: [
      { id: 1, imageUrl: "/comic22_cover.jpg" },
      { id: 2, imageUrl: "/comics/22/page1.enc" },
      { id: 3, imageUrl: "/comics/22/page2.enc" },
      { id: 4, imageUrl: "/comics/22/page3.enc" },
      { id: 5, imageUrl: "/comics/22/page4.enc" },
      { id: 6, imageUrl: "/comics/22/page5.enc" },
    ],
    pagesEs: [
      { id: 1, imageUrl: "/comic22_cover_es.jpg" },
      { id: 2, imageUrl: "/comics/22/es/page1.enc" },
      { id: 3, imageUrl: "/comics/22/es/page2.enc" },
      { id: 4, imageUrl: "/comics/22/es/page3.enc" },
      { id: 5, imageUrl: "/comics/22/es/page4.enc" },
      { id: 6, imageUrl: "/comics/22/es/page5.enc" },
    ],
    coverUrlEs: "/comic22_cover_es.jpg",
  },
  {
    id: 23,
    title: "A short story in the locker room",
    coverUrl: "/comic23_cover.jpg",
    locked: true,
    buyUrl: "https://payhip.com/b/CX1Jc",
    isEncrypted: true,
    pages: [
      { id: 1, imageUrl: "/comic23_cover.jpg" },
      { id: 2, imageUrl: "/comics/23/page1.enc" },
      { id: 3, imageUrl: "/comics/23/page2.enc" },
    ],
    pagesEs: [
      { id: 1, imageUrl: "/comic23_cover_es.jpg" },
      { id: 2, imageUrl: "/comics/23/es/page1.enc" },
      { id: 3, imageUrl: "/comics/23/es/page2.enc" },
    ],
    coverUrlEs: "/comic23_cover_es.jpg",
  },
];

// Free comics section - "Vegeta: The paradise in his feet"
export const freeComics = [
  {
    id: 'free-1',
    title: "Playing With Daddy's Feet",
    coverUrl: "/comics/free/1/cover.enc",
    locked: false,
    isEncrypted: true,
    pages: [
      { id: 1, imageUrl: "/comics/free/1/cover.enc" },
      { id: 2, imageUrl: "/comics/free/1/page1.enc" },
      { id: 3, imageUrl: "/comics/free/1/page2.enc" },
      { id: 4, imageUrl: "/comics/free/1/page3.enc" },
      { id: 5, imageUrl: "/comics/free/1/page4.enc" },
      { id: 6, imageUrl: "/comics/free/1/page5.enc" },
      { id: 7, imageUrl: "/comics/free/1/page6.enc" },
      { id: 8, imageUrl: "/comics/free/1/page7.enc" },
      { id: 9, imageUrl: "/comics/free/1/page8.enc" },
      { id: 10, imageUrl: "/comics/free/1/page9.enc" },
      { id: 11, imageUrl: "/comics/free/1/page10.enc" },
      { id: 12, imageUrl: "/comics/free/1/page11.enc" },
      { id: 13, imageUrl: "/comics/free/1/page12.enc" },
      { id: 14, imageUrl: "/comics/free/1/page13.enc" },
    ],
  },
  {
    id: 'free-2',
    title: "Hey Old Man, Let's Tickle",
    coverUrl: "/comics/free/2/cover.enc",
    locked: false,
    isEncrypted: true,
    pages: [
      { id: 1, imageUrl: "/comics/free/2/cover.enc" },
      { id: 2, imageUrl: "/comics/free/2/page1.enc" },
      { id: 3, imageUrl: "/comics/free/2/page2.enc" },
      { id: 4, imageUrl: "/comics/free/2/page3.enc" },
      { id: 5, imageUrl: "/comics/free/2/page4.enc" },
      { id: 6, imageUrl: "/comics/free/2/page5.enc" },
      { id: 7, imageUrl: "/comics/free/2/page6.enc" },
      { id: 8, imageUrl: "/comics/free/2/page7.enc" },
      { id: 9, imageUrl: "/comics/free/2/page8.enc" },
      { id: 10, imageUrl: "/comics/free/2/page9.enc" },
      { id: 11, imageUrl: "/comics/free/2/page10.enc" },
      { id: 12, imageUrl: "/comics/free/2/page11.enc" },
      { id: 13, imageUrl: "/comics/free/2/page12.enc" },
      { id: 14, imageUrl: "/comics/free/2/page13.enc" },
      { id: 15, imageUrl: "/comics/free/2/page14.enc" },
      { id: 16, imageUrl: "/comics/free/2/page15.enc" },
    ],
  },
  {
    id: 'free-3',
    title: "The Slave Gohan",
    coverUrl: "/comics/free/3/cover.enc",
    locked: false,
    isEncrypted: true,
    pages: [
      { id: 1, imageUrl: "/comics/free/3/cover.enc" },
      { id: 2, imageUrl: "/comics/free/3/page1.enc" },
      { id: 3, imageUrl: "/comics/free/3/page2.enc" },
      { id: 4, imageUrl: "/comics/free/3/page3.enc" },
      { id: 5, imageUrl: "/comics/free/3/page4.enc" },
      { id: 6, imageUrl: "/comics/free/3/page5.enc" },
      { id: 7, imageUrl: "/comics/free/3/page6.enc" },
      { id: 8, imageUrl: "/comics/free/3/page7.enc" },
      { id: 9, imageUrl: "/comics/free/3/page8.enc" },
      { id: 10, imageUrl: "/comics/free/3/page9.enc" },
      { id: 11, imageUrl: "/comics/free/3/page10.enc" },
      { id: 12, imageUrl: "/comics/free/3/page11.enc" },
      { id: 13, imageUrl: "/comics/free/3/page12.enc" },
      { id: 14, imageUrl: "/comics/free/3/page13.enc" },
      { id: 15, imageUrl: "/comics/free/3/page14.enc" },
      { id: 16, imageUrl: "/comics/free/3/page15.enc" },
      { id: 17, imageUrl: "/comics/free/3/page16.enc" },
      { id: 18, imageUrl: "/comics/free/3/page17.enc" },
      { id: 19, imageUrl: "/comics/free/3/page18.enc" },
      { id: 20, imageUrl: "/comics/free/3/page19.enc" },
      { id: 21, imageUrl: "/comics/free/3/page20.enc" },
      { id: 22, imageUrl: "/comics/free/3/page21.enc" },
      { id: 23, imageUrl: "/comics/free/3/page22.enc" },
      { id: 24, imageUrl: "/comics/free/3/page23.enc" },
      { id: 25, imageUrl: "/comics/free/3/page24.enc" },
      { id: 26, imageUrl: "/comics/free/3/page25.enc" },
      { id: 27, imageUrl: "/comics/free/3/page26.enc" },
    ],
  },
  {
    id: 'free-4',
    title: "The Fetish of the Lady",
    coverUrl: "/comics/free/4/cover.enc",
    locked: false,
    isEncrypted: true,
    pages: [
      { id: 1, imageUrl: "/comics/free/4/cover.enc" },
      { id: 2, imageUrl: "/comics/free/4/page1.enc" },
      { id: 3, imageUrl: "/comics/free/4/page2.enc" },
      { id: 4, imageUrl: "/comics/free/4/page3.enc" },
      { id: 5, imageUrl: "/comics/free/4/page4.enc" },
      { id: 6, imageUrl: "/comics/free/4/page5.enc" },
      { id: 7, imageUrl: "/comics/free/4/page6.enc" },
      { id: 8, imageUrl: "/comics/free/4/page7.enc" },
      { id: 9, imageUrl: "/comics/free/4/page8.enc" },
      { id: 10, imageUrl: "/comics/free/4/page9.enc" },
      { id: 11, imageUrl: "/comics/free/4/page10.enc" },
      { id: 12, imageUrl: "/comics/free/4/page11.enc" },
      { id: 13, imageUrl: "/comics/free/4/page12.enc" },
      { id: 14, imageUrl: "/comics/free/4/page13.enc" },
      { id: 15, imageUrl: "/comics/free/4/page14.enc" },
      { id: 16, imageUrl: "/comics/free/4/page15.enc" },
      { id: 17, imageUrl: "/comics/free/4/page16.enc" },
      { id: 18, imageUrl: "/comics/free/4/page17.enc" },
      { id: 19, imageUrl: "/comics/free/4/page18.enc" },
      { id: 20, imageUrl: "/comics/free/4/page19.enc" },
      { id: 21, imageUrl: "/comics/free/4/page20.enc" },
      { id: 22, imageUrl: "/comics/free/4/page21.enc" },
      { id: 23, imageUrl: "/comics/free/4/page22.enc" },
    ],
  },
  {
    id: 'free-5',
    title: "Let's Have Some Fun With Saiyans Feet",
    coverUrl: "/comics/free/5/cover.enc",
    locked: false,
    isEncrypted: true,
    pages: [
      { id: 1, imageUrl: "/comics/free/5/cover.enc" },
      { id: 2, imageUrl: "/comics/free/5/page1.enc" },
      { id: 3, imageUrl: "/comics/free/5/page2.enc" },
      { id: 4, imageUrl: "/comics/free/5/page3.enc" },
      { id: 5, imageUrl: "/comics/free/5/page4.enc" },
      { id: 6, imageUrl: "/comics/free/5/page5.enc" },
      { id: 7, imageUrl: "/comics/free/5/page6.enc" },
      { id: 8, imageUrl: "/comics/free/5/page7.enc" },
      { id: 9, imageUrl: "/comics/free/5/page8.enc" },
      { id: 10, imageUrl: "/comics/free/5/page9.enc" },
      { id: 11, imageUrl: "/comics/free/5/page10.enc" },
      { id: 12, imageUrl: "/comics/free/5/page11.enc" },
      { id: 13, imageUrl: "/comics/free/5/page12.enc" },
      { id: 14, imageUrl: "/comics/free/5/page13.enc" },
      { id: 15, imageUrl: "/comics/free/5/page14.enc" },
      { id: 16, imageUrl: "/comics/free/5/page15.enc" },
      { id: 17, imageUrl: "/comics/free/5/page16.enc" },
      { id: 18, imageUrl: "/comics/free/5/page17.enc" },
      { id: 19, imageUrl: "/comics/free/5/page18.enc" },
      { id: 20, imageUrl: "/comics/free/5/page19.enc" },
      { id: 21, imageUrl: "/comics/free/5/page20.enc" },
      { id: 22, imageUrl: "/comics/free/5/page21.enc" },
      { id: 23, imageUrl: "/comics/free/5/page22.enc" },
    ],
  },
  {
    id: 'free-6',
    title: "A Wish Come True",
    coverUrl: "/comics/free/6/cover.enc",
    locked: false,
    isEncrypted: true,
    pages: [
      { id: 1, imageUrl: "/comics/free/6/cover.enc" },
      { id: 2, imageUrl: "/comics/free/6/page1.enc" },
      { id: 3, imageUrl: "/comics/free/6/page2.enc" },
      { id: 4, imageUrl: "/comics/free/6/page3.enc" },
      { id: 5, imageUrl: "/comics/free/6/page4.enc" },
      { id: 6, imageUrl: "/comics/free/6/page5.enc" },
      { id: 7, imageUrl: "/comics/free/6/page6.enc" },
      { id: 8, imageUrl: "/comics/free/6/page7.enc" },
      { id: 9, imageUrl: "/comics/free/6/page8.enc" },
      { id: 10, imageUrl: "/comics/free/6/page9.enc" },
      { id: 11, imageUrl: "/comics/free/6/page10.enc" },
      { id: 12, imageUrl: "/comics/free/6/page11.enc" },
      { id: 13, imageUrl: "/comics/free/6/page12.enc" },
      { id: 14, imageUrl: "/comics/free/6/page13.enc" },
      { id: 15, imageUrl: "/comics/free/6/page14.enc" },
      { id: 16, imageUrl: "/comics/free/6/page15.enc" },
      { id: 17, imageUrl: "/comics/free/6/page16.enc" },
      { id: 18, imageUrl: "/comics/free/6/page17.enc" },
      { id: 19, imageUrl: "/comics/free/6/page18.enc" },
      { id: 20, imageUrl: "/comics/free/6/page19.enc" },
      { id: 21, imageUrl: "/comics/free/6/page20.enc" },
      { id: 22, imageUrl: "/comics/free/6/page21.enc" },
      { id: 23, imageUrl: "/comics/free/6/page22.enc" },
      { id: 24, imageUrl: "/comics/free/6/page23.enc" },
      { id: 25, imageUrl: "/comics/free/6/page24.enc" },
      { id: 26, imageUrl: "/comics/free/6/page25.enc" },
      { id: 27, imageUrl: "/comics/free/6/page26.enc" },
      { id: 28, imageUrl: "/comics/free/6/page27.enc" },
      { id: 29, imageUrl: "/comics/free/6/page28.enc" },
      { id: 30, imageUrl: "/comics/free/6/page29.enc" },
      { id: 31, imageUrl: "/comics/free/6/page30.enc" },
      { id: 32, imageUrl: "/comics/free/6/page31.enc" },
      { id: 33, imageUrl: "/comics/free/6/page32.enc" },
      { id: 34, imageUrl: "/comics/free/6/page33.enc" },
      { id: 35, imageUrl: "/comics/free/6/page34.enc" },
      { id: 36, imageUrl: "/comics/free/6/page35.enc" },
    ],
  },
];
